import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { partnerSchema, PartnerFormValues } from "@modules/partners/validations";
import { useCreatePartnerMutation } from "@modules/partners/services/mutations";

export function usePartnerCreateForm() {
  const { mutateAsync, isPending } = useCreatePartnerMutation();

  const methods = useForm<PartnerFormValues>({
    resolver: zodResolver(partnerSchema()),
    defaultValues: { active: true },
    mode: "onBlur",
  });

  const { handleSubmit } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
